export default {
  keepAlive:[],
  breadcrumb: null,
  moduleIds:null
};
